import {
  REQUEST_DEVICES,
  REQUEST_REMOVE_DEVICE,
  SET_DEVICES,
  REMOVE_DEVICE_SUCCESS,
  RESET_DEVICES
} from './types';

/**
 * Trusted devices actions
 */
export const requestDevices = () => ({
  type: REQUEST_DEVICES
});

export const requestRemoveDevice = (id, callbacks) => ({
  type: REQUEST_REMOVE_DEVICE,
  payload: {
    id,
    callbacks
  }
});

export const setDevices = devices => ({
  type: SET_DEVICES,
  payload: {
    devices
  }
});

export const removeDeviceSuccess = id => ({
  type: REMOVE_DEVICE_SUCCESS,
  payload: {
    id
  }
});

export const resetDevices = () => ({
  type: RESET_DEVICES
});
